import { render, staticRenderFns } from "./add-holiday.vue?vue&type=template&id=03df3131&"
import script from "./add-holiday.vue?vue&type=script&lang=js&"
export * from "./add-holiday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports